import { getUnixTime } from "date-fns";
import React from "react";
import { useDayPicker } from "react-day-picker";
import { Hide } from "../../../layout/responsive/index.js";
import DayButton from "./DayButton.js";
import WeekNumber from "./WeekNumber.js";
/**
 * https://github.com/gpbl/react-day-picker/tree/main/src/components/Row
 */
function Row(props) {
    const { styles, classNames, showWeekNumber } = useDayPicker();
    return (React.createElement("tr", { className: classNames.row, style: styles.row },
        showWeekNumber && (React.createElement(Hide, { below: "sm", asChild: true },
            React.createElement("td", { className: classNames.cell, style: styles.cell },
                React.createElement(WeekNumber, { number: props.weekNumber, dates: props.dates })))),
        props.dates.map((date) => (React.createElement("td", { className: classNames.cell, style: styles.cell, key: getUnixTime(date) },
            React.createElement(DayButton, { displayMonth: props.displayMonth, date: date }))))));
}
export default Row;
//# sourceMappingURL=Row.js.map